var _path, _rect, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMillustrationsTable = function SvgMillustrationsTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.04,
    d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 23,
    x: 8.5,
    y: 8.5,
    fill: "#fff",
    stroke: "#CCCCD9",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6B2FF",
    stroke: "#A39FEF",
    d: "M10 8.5h36a1.5 1.5 0 0 1 1.5 1.5v5.5h-39V10A1.5 1.5 0 0 1 10 8.5Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 11,
    y: 18,
    fill: "#CCCCD9",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    x: 11,
    y: 22,
    fill: "#CCCCD9",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 11,
    y: 11,
    fill: "#8884C8",
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 2,
    x: 23,
    y: 11,
    fill: "#8884C8",
    rx: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 35,
    y: 11,
    fill: "#8884C8",
    rx: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 11,
    y: 26,
    fill: "#CCCCD9",
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 2,
    x: 23,
    y: 18,
    fill: "#CCCCD9",
    rx: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 2,
    x: 23,
    y: 22,
    fill: "#CCCCD9",
    rx: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 23,
    y: 26,
    fill: "#CCCCD9",
    rx: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 35,
    y: 18,
    fill: "#CCCCD9",
    rx: 1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    x: 35,
    y: 22,
    fill: "#CCCCD9",
    rx: 1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 35,
    y: 26,
    fill: "#CCCCD9",
    rx: 1
  })));
};
export default SvgMillustrationsTable;